// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif; /* Aplica Arial a todo o corpo da página */
}

@media (min-width: 390px) {
  .mobile {
    width: 80%;
    height: 50%;
    border-radius: 5px;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Kanban/responsive.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B,EAAE,0CAA0C;AAC5E;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;AACF","sourcesContent":["body {\n  font-family: Arial, sans-serif; /* Aplica Arial a todo o corpo da página */\n}\n\n@media (min-width: 390px) {\n  .mobile {\n    width: 80%;\n    height: 50%;\n    border-radius: 5px;\n    top: 50%;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    margin-right: -50%;\n    transform: translate(-50%, -50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
